import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useStyle } from '../../context/styleContext/styleContext';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import axios from 'axios';
import { toast } from 'react-hot-toast';

export default function MyGear() {
  const { style } = useStyle();
  const [gear, setGear] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOption, setSortOption] = useState('nameAsc');
  const [selectedLicense, setSelectedLicense] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [width, setWidth] = useState(window.innerWidth


  )
function handleWindowSizeChange() {
    setWidth(window.innerWidth);
}
useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
}, []);

const isMobile = width <= 768;


  useEffect(() => {
    document.title = 'Parish Audio | My Gear';
    getMyGear();
  }, []);

  const getMyGear = async () => {
    const token = localStorage.getItem('token');
    try {
      const { data } = await axios.post('/api/get_my_gear', { token });
      if (data.error) {
        toast.error(data.error);
      } else {
        setGear(data.products);
        setLicenses(data.licenses);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const getLicenseBySKU = (sku) => licenses.find((l) => l.sku === sku);

  const handleOpenDevicesModal = (license) => {
    setSelectedLicense(license);
    setIsModalOpen(true);
  };

  const handleCloseDevicesModal = () => {
    setSelectedLicense(null);
    setIsModalOpen(false);
  };

  const handleRemoveDevice = async (deviceId) => {
    const token = localStorage.getItem('token');
console.log("IP?????")
console.log(selectedLicense.ipAddress);
    try {
      console.log(selectedLicense)

      const { data } = await axios.post('/api/remove_device_from_license', {
        token,
        licenseID: selectedLicense._id,
        ipAddress: deviceId,
      });
      if (data.success) {
        console.log("Updated license")
        console.log(data.updatedLicense);
        console.log("XXXXX")
        setSelectedLicense(data.updatedLicense)
        toast.success('Device removed');
        getMyGear();
        //handleCloseDevicesModal();
      } else {
        toast.error(data.error || 'Failed to remove device');
      }
    } catch (err) {
      toast.error('Error removing device');
      console.error(err);
    }
  };

  const filteredGear = gear
    .filter((item) => {
      if (filter === 'Mac' && !item.macDownloadURI) return false;
      if (filter === 'Windows' && !item.windowsDownloadURI) return false;
      return item.name.toLowerCase().includes(searchTerm.toLowerCase());
    })
    .sort((a, b) => {
      if (sortOption === 'nameAsc') return a.name.localeCompare(b.name);
      if (sortOption === 'nameDesc') return b.name.localeCompare(a.name);
      return 0;
    });

  return (
    <div className='image-background-1'>
      <div className='dark-alpha-80'>
        <Box sx={{ minHeight: '100vh', color: style.color4 }}>
          {isLoading ? (
            <Box sx={{ textAlign: 'center', mt: 10 }}><LoadingSpinner /></Box>
          ) : (
            <>
              {gear.length === 0 ? (
                <Box textAlign="center" mt={10}>
                  <Typography variant="h5">You do not yet have any equipment.</Typography>
                  <Box mt={3}>
                    <a href="/plugins" style={{ color: style.color3 }}>
                      <Typography variant="h6">Shop All Plugins</Typography>
                    </a>
                  </Box>
                </Box>
              ) : (
                <Box sx={{ maxWidth: 1200, mx: 'auto', p: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2, mb: 3 }}>
                    <FormControl sx={{ minWidth: 180 }}>
                      <InputLabel sx={{ color: style.color4 }}>Sort</InputLabel>
                      <Select
                        value={sortOption}
                        onChange={(e) => setSortOption(e.target.value)}
                        size="small"
                        sx={{ color: style.color4, backgroundColor: style.color1 }}
                      >
                        <MenuItem value="nameAsc">Name A–Z</MenuItem>
                        <MenuItem value="nameDesc">Name Z–A</MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      variant="outlined"
                      placeholder="Search by name..."
                      value={searchTerm}
                      size="small"
                      onChange={(e) => setSearchTerm(e.target.value)}
                      sx={{ minWidth: 250, backgroundColor: style.color1, input: { color: style.color4 } }}
                    />
                  </Box>

                  <Grid container spacing={3}>
                    {filteredGear.map((product) => {
                      const license = getLicenseBySKU(product.SKU);
                      const machines = license?.machinesInstalledOn || [];

                      return (
                        <Grid item xs={12} sm={6} md={4} key={product.SKU}>
                          <Card sx={{ backgroundColor: style.color1, color: style.color4 }}>
                            <a href={`/products/${product.productURI}`}>
                              <CardMedia
                                component="img"
                                image={product.images?.[0]?.URI || '/default-image.png'}
                                alt={product.images?.[0]?.altText || 'Product image'}
                                sx={{ maxHeight: 200, maxWidth:200, objectFit: 'contain', p: 0, margin:'auto',  mt:2 }}
                              />
                            </a>
                            <CardContent>
                              <Typography variant="h6">
                                <a href={`/products/${product.productURI}`} style={{ color: style.color4 }}><strong>{product.name}</strong></a>
                              </Typography>
                              <Divider className='divider1' />
                              <div style={{display:'flex', flexDirection:'row' }}>
                                <Typography variant="body1" sx={{ mt: 1 }}>

                                Installed on {machines.length} device{machines.length !== 1 ? 's' : ''}
                              </Typography>
                              {machines.length > 0 && (
                                <Button variant="outlined" size="small" onClick={() => handleOpenDevicesModal(license)} sx={{ mt: 1, ml: 1, borderColor:style.color2, backgroundColor: style.color1, color:style.color4, '&:hover': {backgroundColor: style.color2, color:'white' } }}>
                                  Manage Devices
                                </Button>
                              )}

                              </div>
                              <Typography variant="h6">
                                <strong>Download</strong>
                                </Typography>
                              <div style={{display:'flex', flexDirection:'row'}}>
                              {product.windowsDownloadURI && (
                                <Button href={product.windowsDownloadURI} target="_blank" variant="contained" sx={{ mt: 1, pt:2, margin:'auto', backgroundColor:style.color1, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' } }}>
                                  <div style={{display:'flex', flexDirection:'column'}}>
                                    <div style={{backgroundColor:'black', padding:'5px', paddingLeft:'10px', paddingRight:'10px', paddingTop:'10px'}}>
                                      <img src='windows_logo.png' style={{maxWidth:'80px', maxHeight:'80px', margin:'auto'}} />
                                    </div>
                                    <div style={{textAlign:'center'}}>
                                      <strong>Windows</strong>
                                    </div>
                                  </div>
              
                                </Button>
                              )}
                              {product.macDownloadURI && (
                                <Button href={product.macDownloadURI} target="_blank" variant="contained" sx={{ mt: 1, pt:2, margin:'auto', backgroundColor:style.color1, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' } }}>
                                <div style={{display:'flex', flexDirection:'column'}}>
                                  <div style={{backgroundColor:style.color4, padding:'5px', paddingLeft:'10px', paddingRight:'10px', paddingTop:'10px'}}>
                                    <img src='apple_logo.svg' style={{maxWidth:'80px', maxHeight:'80px', margin:'auto'}} />
                                  </div>
                                  <div style={{textAlign:'center'}}>
                                    <strong>Mac</strong>
                                  </div>
                                </div>
            
                              </Button>
                              )}

                              </div>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              )}
            </>
          )}

          <Dialog open={isModalOpen} onClose={handleCloseDevicesModal} fullWidth maxWidth="md">
            {!isMobile &&(
              <>
              <DialogTitle size="small" sx={{ display: 'flex', pt:0, pb:0,justifyContent: 'space-between', alignItems: 'center', backgroundColor: style.color2, color: style.color4 }}>
               <span style={{fontSize:'1.2em', marginTop:'0px', marginBottom:'0px'}}>{selectedLicense?.productName}</span>
              <IconButton onClick={handleCloseDevicesModal} sx={{ color: style.color4 }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            
            <DialogContent dividers sx={{ backgroundColor: style.color1, color: style.color4 }}>
              <div>

              <h2 style={{fontSize:'1em', marginTop:'0px', marginBottom:'15px'}}>
              Current Devices:
              </h2>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt:0 }}>
              <Typography sx={{fontSize:"1.2em", mr:1, ml:.5}}><strong>IP Address</strong></Typography>
              <Typography sx={{fontSize:"1.2em", mr:1, ml:.5}}><strong>Device</strong></Typography>
              <Typography sx={{fontSize:"1.2em", mr:1, ml:.5}}><strong>Remove </strong></Typography>
                </Box>
              {selectedLicense?.machinesInstalledOn.map((device) => (
                
                <Box key={device.ipAddress} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt:0, p:1 }}>
                  <Typography sx={{fontSize:"1em", mr:.5, ml:.5}}>{device.ipAddress}</Typography>
                  <Typography sx={{fontSize:"1em", mr:.5, ml:.5}}>{device.deviceName} ({device.osName})</Typography>
                  <Button variant="outlined" sx={{ mt: 1, color:style.color4, borderColor:style.color3, minWidth:'75px', borderWidth:'1px', borderStyle:'solid',  backgroundColor:style.color1, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' }}} size="small" onClick={() => handleRemoveDevice(device.ipAddress)}>
                    Remove
                  </Button>
                </Box>
              ))}
              </div>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: style.color1 }}>

              <Button sx={{ mt: 1, borderColor:style.color3, minWidth:'150px', borderWidth:'1px', borderStyle:'solid',  backgroundColor:style.color2, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' }}} onClick={handleCloseDevicesModal} variant="contained">
                <strong>Close</strong>
              </Button>
            </DialogActions>

              </>
            )}




              {isMobile &&(
              <>
              <DialogTitle size="small" sx={{ display: 'flex', pt:0, pb:0,justifyContent: 'space-between', alignItems: 'center', backgroundColor: style.color2, color: style.color4 }}>
               <span style={{fontSize:'1.2em', marginTop:'0px', marginBottom:'0px'}}>{selectedLicense?.productName}</span>
              <IconButton onClick={handleCloseDevicesModal} sx={{ color: style.color4 }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            
            <DialogContent dividers sx={{ backgroundColor: style.color1, color: style.color4 }}>
            <h2 style={{fontSize:'1em', marginTop:'0px', marginBottom:'15px'}}>
              Current Devices:
              </h2>
              <Box sx={{display:'flex', flexDirection:'column'}}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt:0 }}>
              {/* <Typography sx={{fontSize:"1em", mr:1, ml:.5}}><strong>IP Address</strong></Typography>
              <Typography sx={{fontSize:"1em", mr:1, ml:.5}}><strong>Device</strong></Typography>
              <Typography sx={{fontSize:"1em", mr:1, ml:.5}}><strong>Remove </strong></Typography> */}
                </Box>
              {selectedLicense?.machinesInstalledOn.map((device) => (
                
                <Box key={device.ipAddress} sx={{ display: 'flex', flexDirection:'column', justifyContent: 'space-between', mb: 2, mt:0, p:1, boxShadow:5, borderColor:style.color2, borderWidth:'1px', borderStyle:'solid' }}>
                  <Typography sx={{fontSize:"1em", mr:.5, ml:.5}}>IP Address: {device.ipAddress}</Typography>
                  <Typography sx={{fontSize:"1em", mr:.5, ml:.5}}>Device: {device.deviceName}</Typography>
                  <Button variant="outlined" sx={{ mt: 1, color:style.color4, borderColor:style.color3, minWidth:'75px', borderWidth:'1px', borderStyle:'solid',  backgroundColor:style.color1, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' }}} size="small" onClick={() => handleRemoveDevice(device.ipAddress)}>
                    Remove
                  </Button>
                </Box>
              ))}
              </Box>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: style.color1 }}>

              <Button sx={{ mt: 1, borderColor:style.color3, minWidth:'150px', borderWidth:'1px', borderStyle:'solid',  backgroundColor:style.color2, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' }}} onClick={handleCloseDevicesModal} variant="contained">
                <strong>Close</strong>
              </Button>
            </DialogActions>

              </>
            )}

            
          </Dialog>
        </Box>
      </div>
    </div>
  );
}



// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   CardMedia,
//   Typography,
//   Button,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   TextField
// } from '@mui/material';
// import { useStyle } from '../../context/styleContext/styleContext';
// import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
// import axios from 'axios';
// import { toast } from 'react-hot-toast';

// export default function MyGear() {
//   const { style } = useStyle();
//   const [gear, setGear] = useState([]);
//   const [licenses, setLicenses] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [filter, setFilter] = useState('All');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [sortOption, setSortOption] = useState('nameAsc');
//   const [selectedLicense, setSelectedLicense] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     document.title = 'Parish Audio | My Gear';
//     getMyGear();
//   }, []);

//   const getMyGear = async () => {
//     const token = localStorage.getItem('token');
//     try {
//       const { data } = await axios.post('/api/get_my_gear', { token });
//       if (data.error) {
//         toast.error(data.error);
//       } else {
//         setGear(data.products);
//         setLicenses(data.licenses);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//     setIsLoading(false);
//   };

//   const getLicenseBySKU = (sku) => licenses.find((l) => l.sku === sku);

//   const handleOpenDevicesModal = (license) => {
//     setSelectedLicense(license);
//     setIsModalOpen(true);
//   };

//   const handleCloseDevicesModal = () => {
//     setSelectedLicense(null);
//     setIsModalOpen(false);
//   };

//   const handleRemoveDevice = async (deviceId) => {
//     const token = localStorage.getItem('token');
//     try {
//       const { data } = await axios.post('/api/remove_device_from_license', {
//         token,
//         licenseId: selectedLicense._id,
//         deviceId,
//       });
//       if (data.success) {
//         toast.success('Device removed');
//         getMyGear();
//         handleCloseDevicesModal();
//       } else {
//         toast.error(data.error || 'Failed to remove device');
//       }
//     } catch (err) {
//       toast.error('Error removing device');
//       console.error(err);
//     }
//   };

//   const filteredGear = gear
//     .filter((item) => {
//       if (filter === 'Mac' && !item.macDownloadURI) return false;
//       if (filter === 'Windows' && !item.windowsDownloadURI) return false;
//       return item.name.toLowerCase().includes(searchTerm.toLowerCase());
//     })
//     .sort((a, b) => {
//       if (sortOption === 'nameAsc') return a.name.localeCompare(b.name);
//       if (sortOption === 'nameDesc') return b.name.localeCompare(a.name);
//       return 0;
//     });

//   return (
//     <div className='image-background-1'>
//       <div className='dark-alpha-80'>
//         <Box sx={{ minHeight: '100vh', color: style.color4 }}>
//           {isLoading ? (
//             <Box sx={{ textAlign: 'center', mt: 10 }}><LoadingSpinner /></Box>
//           ) : (
//             <>
//               {gear.length === 0 ? (
//                 <Box textAlign="center" mt={10}>
//                   <Typography variant="h5">You do not yet have any equipment.</Typography>
//                   <Box mt={3}>
//                     <a href="/plugins" style={{ color: style.color3 }}>
//                       <Typography variant="h6">Shop All Plugins</Typography>
//                     </a>
//                   </Box>
//                 </Box>
//               ) : (
//                 <Box sx={{ maxWidth: 1200, mx: 'auto', p: 2 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2, mb: 3 }}>
//                     <FormControl sx={{ minWidth: 180 }}>
//                       <InputLabel sx={{ color: style.color4 }}>Sort</InputLabel>
//                       <Select
//                         value={sortOption}
//                         onChange={(e) => setSortOption(e.target.value)}
//                         size="small"
//                         sx={{ color: style.color4, backgroundColor: style.color1 }}
//                       >
//                         <MenuItem value="nameAsc">Name A–Z</MenuItem>
//                         <MenuItem value="nameDesc">Name Z–A</MenuItem>
//                       </Select>
//                     </FormControl>

//                     <TextField
//                       variant="outlined"
//                       placeholder="Search by name..."
//                       value={searchTerm}
//                       size="small"
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       sx={{ minWidth: 250, backgroundColor: style.color1, input: { color: style.color4 } }}
//                     />
//                   </Box>

//                   <Grid container spacing={3}>
//                     {filteredGear.map((product) => {
//                       const license = getLicenseBySKU(product.SKU);
//                       const machines = license?.machinesInstalledOn || [];

//                       return (
//                         <Grid item xs={12} sm={6} md={4} key={product.SKU}>
//                           <Card sx={{ backgroundColor: style.color1, color: style.color4 }}>
//                             <a href={`/products/${product.productURI}`}>
//                               <CardMedia
//                                 component="img"
//                                 image={product.images?.[0]?.URI || '/default-image.png'}
//                                 alt={product.images?.[0]?.altText || 'Product image'}
//                                 sx={{ maxHeight: 200, objectFit: 'contain', p: 1 }}
//                               />
//                             </a>
//                             <CardContent>
//                               <Typography variant="h6">
//                                 <a href={`/products/${product.productURI}`} style={{ color: style.color4 }}>{product.name}</a>
//                               </Typography>
//                               <Typography variant="body2">{product.shortDescription}</Typography>
//                               <Typography variant="body2" sx={{ mt: 1 }}>
//                                 Installed on {machines.length} device{machines.length !== 1 ? 's' : ''}
//                               </Typography>
//                               {machines.length > 0 && (
//                                 <Button variant="outlined" onClick={() => handleOpenDevicesModal(license)} sx={{ mt: 1 }}>
//                                   View Devices
//                                 </Button>
//                               )}
//                               {product.windowsDownloadURI && (
//                                 <Button href={product.windowsDownloadURI} target="_blank" variant="contained" sx={{ mt: 1 }}>
//                                   Download for Windows
//                                 </Button>
//                               )}
//                               {product.macDownloadURI && (
//                                 <Button href={product.macDownloadURI} target="_blank" variant="contained" sx={{ mt: 1 }}>
//                                   Download for Mac
//                                 </Button>
//                               )}
//                             </CardContent>
//                           </Card>
//                         </Grid>
//                       );
//                     })}
//                   </Grid>
//                 </Box>
//               )}
//             </>
//           )}

//           {selectedLicense && (
//             <Box
//               sx={{
//                 position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
//                 bgcolor: 'rgba(0,0,0,0.8)', display: isModalOpen ? 'flex' : 'none',
//                 alignItems: 'center', justifyContent: 'center', zIndex: 1300
//               }}
//               onClick={handleCloseDevicesModal}
//             >
//               <Box
//                 onClick={(e) => e.stopPropagation()}
//                 sx={{ backgroundColor: style.color1, p: 3, borderRadius: 2, width: 500, color: style.color4 }}
//               >
//                 <Typography variant="h6" mb={2}>Devices for SKU {selectedLicense.sku}</Typography>
//                 {selectedLicense.machinesInstalledOn.map((device) => (
//                   <Box key={device._id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                     <Typography>{device.deviceName} ({device.osName})</Typography>
//                     <Button onClick={() => handleRemoveDevice(device._id)} size="small" variant="outlined">
//                       Remove
//                     </Button>
//                   </Box>
//                 ))}
//                 <Button onClick={handleCloseDevicesModal} sx={{ mt: 2 }} variant="contained">Close</Button>
//               </Box>
//             </Box>
//           )}
//         </Box>
//       </div>
//     </div>
//   );
// }



// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   CardMedia,
//   Typography,
//   Button,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   TextField
// } from '@mui/material';
// import { useStyle } from '../../context/styleContext/styleContext';
// import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
// import axios from 'axios';
// import { toast } from 'react-hot-toast';

// export default function MyGear() {
//   const { style } = useStyle();
//   const [gear, setGear] = useState([]);
//   const [licenses, setLicenses] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [filter, setFilter] = useState('All');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [sortOption, setSortOption] = useState('nameAsc');

//   useEffect(() => {
//     document.title = 'Parish Audio | My Gear';
//     getMyGear();
//   }, []);

//   const getMyGear = async () => {
//     const token = localStorage.getItem('token');
//     try {
//       const { data } = await axios.post('/api/get_my_gear', { token });
//       if (data.error) {
//         toast.error(data.error);
//       } else {
//         setGear(data.products);
//         setLicenses(data.licenses)
//         console.log(data);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//     setIsLoading(false);
//   };

//   const filteredGear = gear
//     .filter((item) => {
//       if (filter === 'Mac' && !item.macDownloadURI) return false;
//       if (filter === 'Windows' && !item.windowsDownloadURI) return false;
//       if (!item.name.toLowerCase().includes(searchTerm.toLowerCase())) return false;
//       return true;
//     })
//     .sort((a, b) => {
//       if (sortOption === 'nameAsc') return a.name.localeCompare(b.name);
//       if (sortOption === 'nameDesc') return b.name.localeCompare(a.name);
//       return 0;
//     });

//   return (
//     <div className='image-background-1'>
//           <div className='dark-alpha-80'>
//     <Box sx={{ minHeight: '100vh', color: style.color4, py: 0 }}>
      

//       {isLoading ? (
//         <Box sx={{ textAlign: 'center', mt: 10 }}>
//           <LoadingSpinner />
//         </Box>
//       ) : (
//         <>
//           {gear.length === 0 ? (
//             <Box textAlign="center" mt={10}>
//               <Typography variant="h5">You do not yet have any equipment.</Typography>
//               <Box mt={3}>
//                 <a href="/plugins" style={{ color: style.color3 }}>
//                   <Typography variant="h6">Shop All Plugins</Typography>
//                 </a>
//               </Box>
//             </Box>
//           ) : (
//             <div>
//                 <div style={{maxWidth: 1200, margin:'auto', marginTop:'10px', marginBottom:'10px'}}>
//                     <h1 style={{marginTop:'0px'}}>My Gear</h1>
//                 </div>
//             <Box sx={{ maxWidth: 1200, mx: 'auto', px: 2, backgroundColor:'black', borderColor:style.color1, borderWidth:'2px', borderStyle:'solid', py:2 }}>
//               {/* Centered Filters and Search */}
//               <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2, mb: 3 }}>

//               <FormControl sx={{ minWidth: 180 }}>
//                 <InputLabel
//                     sx={{
//                     color: style.color4,
//                     '&.Mui-focused': {
//                         color: style.color3,
//                     },
//                     }}
//                 >
//                     Sort
//                 </InputLabel>
//                 <Select
//                     value={sortOption}
//                     onChange={(e) => setSortOption(e.target.value)}
//                     size="small"
//                     sx={{
//                     color: style.color4,
//                     backgroundColor: style.color1,
//                     borderRadius: 1,
//                     '.MuiSvgIcon-root': { color: style.color4 },
//                     '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                         borderColor: style.color3,
//                     },
//                     '& .MuiOutlinedInput-notchedOutline': {
//                         borderColor: 'transparent',
//                     },
//                     '&:hover .MuiOutlinedInput-notchedOutline': {
//                         borderColor: style.color3,
//                     },
//                     '&.Mui-focused fieldset': {
//                         borderColor: style.color3,
//                     },
//                     }}
//                 >
//                     <MenuItem value="nameAsc">Name A–Z</MenuItem>
//                     <MenuItem value="nameDesc">Name Z–A</MenuItem>
//                 </Select>
//                 </FormControl>

//                 <TextField
//                 variant="outlined"
//                 placeholder="Search by name..."
//                 value={searchTerm}
//                 size="small"
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 sx={{
//                     minWidth: 250,
//                     backgroundColor: style.color1,
//                     input: { color: style.color4 },
//                     '& .MuiOutlinedInput-root': {
//                     '& fieldset': {
//                         borderColor: 'transparent',
//                     },
//                     '&:hover fieldset': {
//                         borderColor: style.color3,
//                     },
//                     '&.Mui-focused fieldset': {
//                         borderColor: style.color3,
//                     },
//                     },
//                     '& .MuiInputLabel-root': {
//                     color: style.color4,
//                     '&.Mui-focused': {
//                         color: style.color3,
//                     },
//                     },
//                 }}
//                 />
//               </Box>

//               {/* Gear Grid */}
//               <Box display="flex" justifyContent="center">
//                 <Grid container spacing={3} justifyContent="center" maxWidth="lg">
//                   {filteredGear.map((product) => (
//                     <Grid item xs={12} sm={6} md={4} key={product.SKU}>
//                       <Card
//                         sx={{
//                           height: '100%',
//                           display: 'flex',
//                           flexDirection: 'column',
//                           backgroundColor: style.color1,
//                           color: style.color4,
//                         }}
//                       >
//                         <a href={'/products/' + product.productURI}>
//                             <CardMedia
//                             component="img"
//                             image={product.images?.[0]?.URI || '/default-image.png'}
//                             alt={product.images?.[0]?.altText || 'Product image'}
//                             sx={{
//                                 maxHeight: 200,
//                                 objectFit: 'contain',
//                                 backgroundColor: 'rgba(0, 0, 0, 0.6)',
//                                 border: `5px solid ${style.color1}`,
//                                 borderRadius: 1,
//                                 p: 1,
//                                 boxSizing: 'border-box',
//                             }}
//                             /></a>
//                         <CardContent sx={{ flexGrow: 1 }}>
//                           <Typography variant="h6" gutterBottom>
//                           <a href={'/products/' + product.productURI}>{product.name}</a>
//                           </Typography>
//                           <Typography variant="body2" sx={{ mb: 2 }}>
//                             {product.shortDescription}
//                           </Typography>
//                           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//                             {product.windowsDownloadURI && (
//                               <Button
//                                 variant="contained"
//                                 href={product.windowsDownloadURI}
//                                 target="_blank"
//                                 sx={{
//                                   backgroundColor: style.color2,
//                                   color: style.color4,
//                                   '&:hover': {
//                                     backgroundColor: style.color3,
//                                   },
//                                 }}
//                               >
//                                     Download for Windows

//                               </Button>
//                             )}
//                             {product.macDownloadURI && (
//                               <Button
//                                 variant="contained"
//                                 href={product.macDownloadURI}
//                                 target="_blank"
//                                 sx={{
//                                   backgroundColor: style.color2,
//                                   color: style.color4,
//                                   '&:hover': {
//                                     backgroundColor: style.color3,
//                                   },
//                                 }}
//                               >
//                                 Download for Mac
//                               </Button>
//                             )}
//                           </Box>
//                         </CardContent>
//                       </Card>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Box>
//             </Box>
//             </div>
//           )}
//         </>
//       )}
//     </Box>
//     </div>
//     </div>
//   );
// }